import { Button, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles((theme: any) => ({
  button: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.4rem",
      height: "36px",
      minWidth: 110,
      padding: "0 12px"
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.6rem",
      lineHeight: "5rem",
      marginLeft: "24px", // pass this as a class style
      minWidth: 160,
      padding: "0 16px",
      maxHeight: "44px"
    },
    fontWeight: 600,
    boxShadow: "none"
  },
  disabled: {
    backgroundColor: "#c0c0c0 !important",
    color: "#ffffff !important"
  },
  large: {
    [theme.breakpoints.up("md")]: {
      fontSize: "2.4rem",
      lineHeight: "6rem",
      minHeight: 60,
      minWidth: 200
    },
    fontSize: "1.8rem",
    fontWeight: 600,
    minHeight: 45,
    minWidth: 124,
    padding: "0 16px",
    textTransform: "none" as "none"
  },
  primary: {
    "&:hover": {
      backgroundColor: `${theme.palette.primary.light} !important`
    }
  },
  secondary: {
    "&:hover": {
      backgroundColor: `${theme.palette.secondary.light} !important`
    }
  },
  small: {
    lineHeight: "3.6rem"
  }
}));

interface IOwnProps {
  className?: string;
  color?: "primary" | "secondary";
  children: React.ReactNode;
  dataTestId?: string;
  disabled?: boolean;
  type?: "button" | "submit";
  onClick?: any;
  size?: "large" | "default" | "small";
}

const CustomButton = ({
  className = "",
  color = "primary",
  dataTestId,
  size = "default",
  disabled = false,
  type,
  children,
  onClick
}: IOwnProps) => {
  const classes = useStyles();

  const getSizeClassNames = React.useCallback(() => {
    switch (size) {
      case "small":
        return [classes.small];
      case "large":
        return [classes.large];
      default:
        return [];
    }
  }, [size]);

  const classNames = getSizeClassNames().concat([classes.button, classes[color], className]);

  return (
    <Button
      data-qa-selector={dataTestId}
      classes={{ disabled: classes.disabled }}
      disabled={disabled}
      onClick={onClick}
      type={type}
      className={classNames.join(" ")}
      variant="contained"
      color={color}
    >
      {children}
    </Button>
  );
};

export const ContainedButton = React.memo(CustomButton);
